import { ChangeDetectionStrategy, Component, Injectable } from '@angular/core';
import { NgbToastConfig } from '@ng-bootstrap/ng-bootstrap';

import AppSettings from '../../app.settings';
import { ToastsContainerComponent } from '../toasts-container/toasts-container.component';

@Injectable({ providedIn: 'root' })
class AppToastConfig extends NgbToastConfig {
  public override delay = AppSettings.DEFAULT_TOAST_DELAY;
  public override autohide = true;
}

@Component({
  selector: 'app-toast-global',
  templateUrl: './toast-global.component.html',
  styleUrls: ['./toast-global.component.scss'],
  imports: [ToastsContainerComponent],
  providers: [{ provide: NgbToastConfig, useClass: AppToastConfig }],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastGlobalComponent {}
